import { NodeInterface, TagInterface, TeamInterface } from '../../../index';

export interface SiteInterface {
  guid: string;
  id: string;
  owner?: {
    guid: string;
    name: string;
  };
  isPrivate?: boolean;
  isInTeam?: boolean;
  isMws: boolean;
  extenders: NodeInterface[];
  tags: TagInterface[];
  name: string;
  operations: SiteOperationsInterface;
  controller: NodeInterface;
  isFailSafeMode: boolean;
  keenDnsAddress?: string;
  systemAddress?: string;
  clientCount: number;
  nodeCount: number;
  mainWanConnection: SiteWanConnectionInterface;
  reserveWanConnections: SiteWanConnectionInterface[];
  locationAddress: string;
  description: SiteDescriptionInterface;
  shareType: SiteShareTypeEnum;
  teams: TeamInterface[];
}

export interface SiteDescriptionInterface {
  note1: string;
  note2: string;
  email: string;
  comment: string;
}

export interface SiteOperationsInterface {
  guid: string;
  owner?: {
    guid: string;
    name: string;
  };
  isPrivate?: boolean;
  changeInformation: SiteOperationInterface;
  confirmRights: SiteOperationInterface;
  authUrl: SiteOperationInterface;
  osUpdate: SiteOperationInterface;
  reboot: SiteOperationInterface;
  remove: SiteOperationInterface;
  rename: SiteOperationInterface;
  share: SiteOperationInterface;
  registration: SiteOperationInterface;
  deregistration: SiteOperationInterface;
}

export interface SiteOperationInterface {
  canRun: boolean;
  isInProgress: boolean;
  conditions: string[];
  guid: string;
  owner?: {
    guid: string;
    name: string;
  };
  isPrivate?: boolean;
}

export interface SiteWanConnectionInterface {
  guid: string;
  owner?: {
    guid: string;
    name: string;
  };
  isPrivate?: boolean;
  id: number;
  description: string;
  ipConflict: {
    ipAddress: string;
    ipMask: string;
  } | null;
  type: SiteConnectionTypeEnum;
  isConnected: boolean;
  isEnabled: boolean;
  isMain: boolean;
  weight: number;
  failType: string | null;
  failTypeDescription: string | null;
  uptime: number | null;
  tunnelType: string | null;
  speed?: number;
  rssi?: number;
  rate?: number;
  cinr?: number;
  dsNoise?: number;
  usNoise?: number;
  signalLevel?: number;
  wifiBand?: string;
  ethernetConnectorType?: string;
  operationMode?: string;
}

export interface SiteDataInterface {
  items: SiteInterface[];
  itemsCount: number;
  totalItemsCount: number;
  pinnedItems: string[];
}

export enum SiteConnectionTypeEnum {
  TUNNEL = 'TUNNEL',
  ETHERNET = 'ETHERNET',
  MOBILE = 'MOBILE',
  WISP = 'WISP',
  DSL = 'DSL',
  BRIDGE = 'BRIDGE',
  UNKNOWN = 'UNKNOWN',
}

export enum SiteShareTypeEnum {
  PRIVATE = 'private',
  SHARED_BY_ME = 'shared_by_me',
  SHARED_WITH_ME = 'shared_with_me',
}

export const siteShareTypeIconMap = {
  [SiteShareTypeEnum.SHARED_WITH_ME]: 'shared-with-me',
  [SiteShareTypeEnum.SHARED_BY_ME]: 'shared-by-me',
  [SiteShareTypeEnum.PRIVATE]: undefined,
};

export const siteShareTypeIconTooltipMap = {
  [SiteShareTypeEnum.SHARED_WITH_ME]: $localize`:@@sitesSharedWithMeSiteStatusTooltip:Shared with me`,
  [SiteShareTypeEnum.SHARED_BY_ME]: $localize`:@@sitesSharedByMeSiteStatusTooltip:Shared by me`,
  [SiteShareTypeEnum.PRIVATE]: undefined,
};
